const EnxVb = require('./components/vb').default
export const initVB = (options) => {
    let vb = new EnxVb(options);
    return vb;
};